import CommonModal from "../../ResetContext/components/DumpModal";
import { Warning } from "@mui/icons-material";
import DoneIcon from "@mui/icons-material/Done";

const texts = [
  {
    icon: <DoneIcon style={{ color: "green", marginTop: "8px" }} />,
    text: "Your existing work will remain saved in your account",
  },
  {
    icon: <Warning style={{ color: "#ed8f15", marginTop: "8px" }} />,
    text: "You'll lose access to all premium features.",
  },
  {
    icon: <Warning style={{ color: "#ed8f15", marginTop: "8px" }} />,
    text: "Team members will no longer have access.",
  },
];

const CancelModal = ({ isOpen, onClose, setOpenConfirmModal }) => {
  return (
    <CommonModal title="" showAlert={false} onClose={onClose} isOpen={isOpen}>
      <h4 className="text-xl font-semibold text-center mb-2">
        Cancel Your Plan
      </h4>
      <p className="px-4 text-center text-[#464646] mb-4">
        You're about to cancel your plan. This action is permanent and cannot be
        undone.
      </p>
      {texts.map((item, index) => (
        <div className="mx-4 flex gap-4 py-5 border-b items-center" key={index}>
          {item.icon}
          <p key={index} className="mt-2 text-lg font-medium">
            {item.text}
          </p>
        </div>
      ))}
      <div className="mt-8 flex flex-col ">
        <button
          onClick={() => {
            setOpenConfirmModal(true);
            onClose();
          }}
          className="px-4 py-3 font-medium bg-black text-white rounded-md"
        >
          Cancel plan
        </button>
        <button
          onClick={onClose}
          className="px-4 font-medium py-3 mt-3 rounded-md border"
        >
          Keep my existing plan
        </button>
      </div>
    </CommonModal>
  );
};

export default CancelModal;
